import { isPast } from "date-fns";
import { useState } from "react";
import { Outlet } from "react-router";
import { getStaffSession, type StaffSession } from "../utilities/staffSession";
import { StaffSessionBanner } from "./StaffSessionBanner";
import { StaffSessionExpired } from "./StaffSessionExpired";

export const StaffSessionLayout = () => {
  const [staffSession] = useState<StaffSession | null>(() => getStaffSession());
  const [isExpired, setIsExpired] = useState(() => {
    const session = getStaffSession();
    return session ? isPast(session.expires) : false;
  });

  const handleSessionExpired = () => {
    setIsExpired(true);
  };

  return (
    <div className="flex size-full flex-col">
      {staffSession && !isExpired && (
        <StaffSessionBanner
          session={staffSession}
          onExpired={handleSessionExpired}
        />
      )}
      {isExpired && <StaffSessionExpired />}
      <div className="flex min-h-0 flex-auto flex-col">
        <Outlet />
      </div>
    </div>
  );
};
